import { MonitorKey } from './monitor-key.type';

export class MonitorTagPluralAssignmentModel {
	MonitorTagId: number;
	MonitorKeys: MonitorKey[];

	constructor(monitorKeys: MonitorKey[], tagId: number = null) {
		this.MonitorTagId = tagId;
		this.MonitorKeys = monitorKeys;
	}
}
